import React from 'react';

import './ReviewList.scss';
import icons from '../../shared/assets/icons';
import { getString } from '../../helpers/styles';

const { Star, HalfStar } = icons;

export default function ReviewList(props) {
  return (
    <section id="reviewList">
      <h2>Recensies</h2>

      <ul>
        {props.list.map((item, idx) => (
          <li key={idx}>
            <p className="reviewList_text">
              <span className="reviewList_text_begin" />

              {item.text}

              <span className="reviewList_text_end" />
            </p>

            <div className="reviewList_stars">
              {Array.from({ length: 5 }).map((_, idx) => (
                <span
                  className={getString(
                    'reviewList_star_filled',
                    idx < item.stars
                  )}
                  key={idx}
                >
                  {!Number.isInteger(item.stars) &&
                  idx === Math.floor(item.stars) ? (
                    <span className="reviewList_half_star">
                      <HalfStar />
                    </span>
                  ) : (
                    <Star />
                  )}
                </span>
              ))}
            </div>

            <img src={item.authorImage} alt="author-image" />

            <p>{item.authorName}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
